export default __webpack_public_path__ + "static/hero-custom-branding-fe70b3a1d156d943b2e1a82d64831b37.svg";